import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'

import { useStyles } from './AdminDocs_style'

const AdminDocs = (props) => {
    const classes = useStyles()
    const [documentation, setDocumentation] = useState('')

    useEffect(() => {
        import('./AdminDoc.md')
            .then((module) => {
                setDocumentation(module.default);
            })
    }, [])

    return (
        <div className={classes?.container || ''}>
            <ReactMarkdown children={documentation} />
        </div>
    )
}

export default AdminDocs
